import React, {PureComponent} from 'react';
import ReactQuill from 'react-quill';

import TooltipValidator from './TooltipValidator.jsx';

import conf from '../../../conf.js';

import 'react-quill/dist/quill.snow.css';
import './Quill.scss';

let it = 0;

const toolbarOptions = {
  toolbar: [
    [{header: [1, 2, 3, false]}],
    ['bold', 'italic', 'underline'],
    ['link'],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'color': [conf.colors.blue]}],
    ['clean']
  ]
}

export default class Quill extends PureComponent {
  render() {
    const {input, meta, className, ...field} = this.props;

    const name = 'quill' + (input.name || it++);
    const id = `${meta.form}_${name}`.replace('.', '_');

    let classes = className || '';
    if (meta.visited || !meta.pristine || meta.submitFailed) {
      if (meta.valid) {
        classes += ' is-valid';
      } else {
        classes += ' is-invalid';
      }
    }

    return <div className="form-group">
      {field.label ? <label htmlFor={id}>{field.label}</label> : ''}
      <TooltipValidator field={this.props} target={id}/>
      <ReactQuill
        id={id}
        className={classes}
        value={input.value}
        closeOnSelect={true}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        modules={toolbarOptions}
        {...field}
      />
    </div>;
  }

  onBlur = () => {
    this.props.input.onBlur();
  }

  onFocus = () => {
    this.props.input.onFocus();
  }

  onChange = (content) => {
    this.props.input.onChange(content);
  }
}
